/** Vendor Discovery grid — FE column key → API sort_by. */

import { sortConfigToApiParams } from "./gridSortApiParams";

export function dedupeProvidersById(items) {
  const seen = new Set();
  const result = [];
  for (const item of items || []) {
    const id = item?.id != null ? String(item.id) : null;
    if (id) {
      if (seen.has(id)) continue;
      seen.add(id);
    }
    result.push(item);
  }
  return result;
}

export const DISCOVERY_USE_SERVER_SORT = true;

export const DISCOVERY_API_SORT_FIELD = {
  name: "name",
  type: "type",
  location: "location",
};

/**
 * @param {Record<string, { direction?: string }>} sortConfig
 *   or legacy { column, direction } from discovery.jsx
 * @returns {{ orderBy: string, sortDirection: 'asc' | 'desc' } | undefined}
 */
export function sortConfigToDiscoveryApiParams(
  sortConfigOrColumn,
  enabled = DISCOVERY_USE_SERVER_SORT
) {
  if (!enabled) return undefined;

  if (sortConfigOrColumn && typeof sortConfigOrColumn === "object" && "column" in (sortConfigOrColumn || {})) {
    const { column, direction } = sortConfigOrColumn;
    if (!column || (direction !== "asc" && direction !== "desc")) return undefined;
    const orderBy = DISCOVERY_API_SORT_FIELD[column];
    if (!orderBy) return undefined;
    return { orderBy, sortDirection: direction };
  }

  return sortConfigToApiParams(sortConfigOrColumn, DISCOVERY_API_SORT_FIELD, true);
}
